import React from 'react';

const GiveFreeSubscription = ({ free_subscription, makeFree }) => (
  free_subscription ? (null) : (
    <span>
      <span className="separator"> | </span>
      <a onClick={makeFree}>Grant Free Subscription</a>
    </span>

  )
)

export default GiveFreeSubscription



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/GiveFreeSubscription.js